










import { Vue, Component, Prop } from 'vue-property-decorator';
import { Editor as TipTapEditor, Text, Paragraph } from 'tiptap';
import { InputDocNode, EnterBreakNode } from '@/editor/tiptap/nodes';
import { EProsemirrorType } from '@/editor/types/enums';
import { ITextContentDoc } from '@/editor/types';
import ProsemirrorWrapper from '@/editor/editor-block/components/ProsemirrorWrapper.vue';

@Component({
  components: {
    ProsemirrorWrapper,
  },
})
export default class ProsemirrorViewerInput extends Vue {
  @Prop() content: ITextContentDoc;

  viewer: TipTapEditor | null = null;

  get inputViewer() {
    return {
      content: this.content,
      editable: false,
      useBuiltInExtensions: false,
      extensions: [new InputDocNode(), new EnterBreakNode(), new Text(), new Paragraph()],
      disableInputRules: true,
      disablePasteRules: true,
      emptyDocument: {
        type: EProsemirrorType.Doc,
        content: [
          {
            type: EProsemirrorType.Paragraph,
          },
        ],
      },
      dropCursor: {
        color: 'transparent',
      },
    };
  }

  handleLoaded() {
    Vue.nextTick(() => {
      this.$emit('loaded');
    });
  }

  mounted() {
    this.viewer = new TipTapEditor(this.inputViewer);
  }

  beforeDestroy() {
    this.viewer.destroy();
  }
}
